import { helper as buildHelper } from '@ember/component/helper';

/**
 * This will if the message bubble is linkable.
 *
 * @param params
 * @return {Boolean}
 */
export function projectDetailsIsMessageBubbleLinkable(params/*, hash*/) {
  let userViewing = params[0],
    activityItem = params[1];

  return activityItem.get('user.id') !== userViewing.get('id');
}

export default buildHelper(projectDetailsIsMessageBubbleLinkable);
